const warningPrefix = '[Env Check]';

const warn = (message) => {
  if (process.env.NODE_ENV === 'test') return;
  console.warn(`${warningPrefix} ${message}`);
};

const warnIfMissing = (key, fallback) => {
  if (!process.env[key]) {
    warn(`${key} is not set. Using fallback "${fallback}".`);
  }
};

export const validateEnvironment = () => {
  warnIfMissing('REACT_APP_BASE_URL', 'http://localhost:8069');
  warnIfMissing('REACT_APP_SOCKET_URL', 'https://virtual-ws.perla-tech.com/');
  warnIfMissing('REACT_APP_RECORDING_URL', 'REACT_APP_SOCKET_URL');
  warnIfMissing('REACT_APP_WEBSITE_URL', 'https://torbet.com');
  warnIfMissing('REACT_APP_DESKTOP_APP_DOWNLOAD_URL', 'https://shorturl.at/JSVZ9');
  warnIfMissing('REACT_APP_STUN_URL', 'stun:5.134.255.233:3478');

  const hasAnyTurnValue = ['REACT_APP_TURN_URL', 'REACT_APP_TURN_USERNAME', 'REACT_APP_TURN_CREDENTIAL']
    .some((key) => !!process.env[key]);
  const hasAllTurnValues = ['REACT_APP_TURN_URL', 'REACT_APP_TURN_USERNAME', 'REACT_APP_TURN_CREDENTIAL']
    .every((key) => !!process.env[key]);

  if (hasAnyTurnValue && !hasAllTurnValues) {
    warn('TURN configuration is partial. Set REACT_APP_TURN_URL, REACT_APP_TURN_USERNAME, and REACT_APP_TURN_CREDENTIAL together.');
  }

  warnIfMissing('REACT_APP_SERVER_HANDLER_TOKEN', 'server-handler-token');
  warnIfMissing('REACT_APP_SERVER_HANDLER_USER_ID', 'server-handler-id');
  warnIfMissing('REACT_APP_SERVER_HANDLER_USER_NAME', 'server-handler');
  warnIfMissing('REACT_APP_SERVER_HANDLER_RECORDING_TOKEN', 'server-handler-recording-token');
  warnIfMissing('REACT_APP_SERVER_HANDLER_RECORDING_USER_ID', 'server-handler-recording-id');
  warnIfMissing('REACT_APP_SERVER_HANDLER_RECORDING_USER_NAME', 'server-handler-recording');
};

export default validateEnvironment;
